module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_27 (34).e3aa34b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_27 (34).mp4
// module id = 809
// module chunks = 1